module.exports = __webpack_public_path__ + "static/media/notif.c511064c.svg";